import * as Constants from '../../constants';

import { useEffect, useState } from 'react';

import { Button, Container } from "react-bootstrap";

import { faTrash, faPlus, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomersDashboardCards from '../../components/admin/customers/CustomersDashboardCards.jsx';
import CustomersTable from '../../components/admin/customers/CustomersTable.jsx';
import ConfirmationModal from '../../components/widget/ConfirmationModal.jsx';
import Loading from '../../components/widget/Loading.js';
import CustomerForm from '../../components/admin/customers/CustomerForm.jsx';

function CustomersPage() {
    // mode: 0 (listagem), 1 (criação), 2 (edição)
    const [mode, setMode] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [customers, setCustomers] = useState([]);
    const [customerTypes, setCustomerTypes] = useState([]);
    const [statusTypes, setStatusTypes] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleEdit = (customer) => {
        setSelectedCustomer(customer);
        setMode(2); // Modo 2 para edição
    }

    const handleDelete = (customer) => {
        setSelectedCustomer(customer)
        setShowDeleteModal(true)
    }

    const handleDeleteConfirmation = (id) => {
        setShowDeleteModal(false)
        setIsLoading(true);

        const controller = new AbortController();
        const signal = controller.signal;
        const token = localStorage.getItem("token");

        fetch(Constants.CUSTOMERS_DELETE, {
            method: 'DELETE',
            signal: signal,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: id }),
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => { throw err; });
                }
                return response.json();
            })
            .then(responseJson => {
                if (responseJson.status === "success") {
                    setCustomers(prevCustomers => prevCustomers.filter(customer => customer.id !== id));
                } else {
                    console.error('Erro na API:', responseJson.message);
                }
                setSelectedCustomer(null);
                setIsLoading(false);
            })
            .catch(error => {
                if (error.name === 'AbortError') return;

                console.error('Erro na requisição de remoção:', error.message || error);
                setIsLoading(false);
            });
    }

    const handleCreate = () => {
        setSelectedCustomer(null); // Limpa para garantir novo cadastro vazio
        setMode(1); // Modo 1 para criação
    }

    const handleSave = (customer) => {
        setIsLoading(true);

        let url = Constants.CUSTOMERS_CREATE;
        let method = 'POST';
        if (customer.id) {
            url = Constants.CUSTOMERS_UPDATE;
            method = 'PUT';
        }
        const controller = new AbortController();
        const signal = controller.signal;

        const token = localStorage.getItem("token");

        fetch(url, {
            method: method,
            signal: signal,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(customer),
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => { throw err; });
                }
                return response.json();
            })
            .then(responseJson => {
                if (responseJson.status === "success") {
                    const savedCustomer = responseJson.data; 
                    if (customer.id) {
                        setCustomers(prev => prev.map(u => u.id === savedCustomer.id ? savedCustomer : u));
                    } else {
                        setCustomers(prev => [...prev, savedCustomer]);
                    }
                    setMode(0); // Retorna para a listagem após salvar com sucesso
                }
                setIsLoading(false);
            })
            .catch(error => {
                if (error.name === 'AbortError') {
                    return;
                }
                console.error('Erro na requisição:', error.message || error);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setIsLoading(true);
                const token = localStorage.getItem("token");

                const headers = {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                };

                const [customersRes, customerTypesRes, statusTypesRes] = await Promise.all([
                    fetch(Constants.CUSTOMERS_LIST, { method: 'GET', signal, headers }),
                    fetch(Constants.LICENSE_TYPES_LIST, { method: 'GET', signal, headers }),
                    fetch(Constants.LICENSE_STATUS_LIST, { method: 'GET', signal, headers })
                ]);

                if (!customersRes.ok) throw await customersRes.json();
                if (!customerTypesRes.ok) throw await customerTypesRes.json();
                if (!statusTypesRes.ok) throw await statusTypesRes.json();

                const customersJson = await customersRes.json();
                const customerTypesJson = await customerTypesRes.json();
                const statusTypesJson = await statusTypesRes.json();

                if (customersJson.status === "success") setCustomers(customersJson.data);
                if (customerTypesJson.status === "success") setCustomerTypes(customerTypesJson.data);
                if (statusTypesJson.status === "success") setStatusTypes(statusTypesJson.data);
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error(error);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    return <>
        <div className="container">
            {!isLoading &&
                <>
                    <Container fluid className="mt-4 mb-5">
                        {
                            mode === 0 &&
                            <>
                                <h3 style={{ color: '#fff' }}><FontAwesomeIcon icon={faUsers} /> Clientes :: Listagem</h3>
                                <Button onClick={handleCreate}>
                                    <FontAwesomeIcon icon={faPlus} /> Novo Cliente
                                </Button>
                            </>
                        }
                        {
                            mode > 0 &&
                            <>
                                {/* Correção do bug de execução imediata com arrow function */}
                                <h3 style={{ color: '#fff' }}>
                                    <FontAwesomeIcon icon={faUsers} />{" "}
                                    <span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => setMode(0)}>
                                        Clientes
                                    </span>{" "}
                                    :: {mode === 1 ? 'Cadastrar' : 'Editar'}
                                </h3>
                            </>
                        }
                    </Container>

                    {mode === 0 && <>
                        <CustomersDashboardCards customers={customers} />
                        <CustomersTable
                            customers={customers}
                            customerTypes={customerTypes}
                            statusTypes={statusTypes}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </>}

                    {/* Exibe o formulário quando mode for 1 ou 2 */}
                    {(mode === 1 || mode === 2) && (
                        <CustomerForm 
                            customer={selectedCustomer} 
                            onSave={handleSave} 
                            onCancel={() => setMode(0)} 
                        />
                    )}
                </>
            }
            {isLoading && <>
                <Loading />
            </>}

            {showDeleteModal && <ConfirmationModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onConfirm={handleDeleteConfirmation}
                title="Remover Cliente"
                message={<p>Tem certeza que deseja excluir o cliente <strong>{selectedCustomer?.nome_razao_social || selectedCustomer?.name}</strong>?</p>}
                confirmText="Excluir Agora"
                confirmVariant="danger"
                icon={faTrash}
                isLoading={isLoading}
                id={selectedCustomer.id}
            />
            }
        </div>
    </>
}

export default CustomersPage;